<template>
  <div class="min-h-screen">
    <div class="flex items-center justify-center h-16 py-2 bg-dark-type-1">
      <router-link to="/">
        <img src="@/assets/img/logo.png" style="width: 160px" alt="Shuttlers" />
      </router-link>
    </div>
    <div class="flex flex-col items-center justify-center min-h-screen">
      <div class="w-full">
        <privacy-policy :show-close-toggle="false"></privacy-policy>
      </div>
    </div>
  </div>
</template>

<script>
import PrivacyPolicy from "@/components/PrivacyPolicy";

export default {
  components: {
    PrivacyPolicy
  },
  data() {
    return {};
  },
};
</script>